function c(t) {
  var o = t == null ? void 0 : t.constructor,
    r = typeof o == "function" ? o.prototype : Object.prototype;
  return t === r;
}
export { c as isPrototype };